import {
  DatePrecision,
  DateQualifier,
  type PartialDate,
} from '@heritage/shared';
import type { Person, PersonFact } from '@/types/api';

export { formatPartialDate } from '@heritage/shared';

function buildDate(
  year: number | null | undefined,
  month: number | null | undefined,
  day: number | null | undefined,
  precision: string | null | undefined,
  qualifier: string | null | undefined,
  raw: string | null | undefined,
): PartialDate {
  return {
    year: year ?? null,
    month: month ?? null,
    day: day ?? null,
    precision: (precision as DatePrecision) ?? DatePrecision.UNKNOWN,
    qualifier: (qualifier as DateQualifier) ?? DateQualifier.EXACT,
    raw: raw ?? null,
  };
}

export function personBirthDate(person: Person): PartialDate {
  return buildDate(
    person.birthYear,
    person.birthMonth,
    person.birthDay,
    person.birthPrecision,
    person.birthQualifier,
    person.birthDateRaw,
  );
}

export function personDeathDate(person: Person): PartialDate {
  return buildDate(
    person.deathYear,
    person.deathMonth,
    person.deathDay,
    person.deathPrecision,
    person.deathQualifier,
    person.deathDateRaw,
  );
}

export function factDate(fact: PersonFact): PartialDate {
  return buildDate(
    fact.dateYear,
    fact.dateMonth,
    fact.dateDay,
    fact.datePrecision,
    fact.dateQualifier,
    fact.dateRaw,
  );
}

export function hasDate(value: PartialDate | null | undefined): boolean {
  return Boolean(
    value &&
      (value.year ||
        (value.month !== null && value.month !== undefined) ||
        value.day ||
        value.raw),
  );
}
